import { Headline, HeadlineProps } from '@awaze/design-system.components.text'
import { Document } from '@contentful/rich-text-types'
import {
  BaseGrid,
  BaseGridItem,
} from '@awaze/design-system.components.base-grid'
import RichText from '@/components/RichText/RichText'

export interface SeoTextModuleProps {
  headline?: HeadlineProps
  text?: Document
  textColor?: 'light' | 'dark'
}

export const SeoTextModule: React.FC<SeoTextModuleProps> = ({
  headline,
  text,
  textColor,
}) => (
  <div>
    <BaseGrid flush>
      <BaseGridItem columns={[12, 3]}>
        {headline && <Headline {...headline} />}
      </BaseGridItem>
      <BaseGridItem columns={[12, 9]}>
        {text && (
          <RichText
            content={text}
            textColor={
              textColor === 'light'
                ? 'ColorTextBodyOnDark'
                : 'ColorTextBodyOnWhite'
            }
          />
        )}
      </BaseGridItem>
    </BaseGrid>
  </div>
)
